import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const STAFF_ROLES = ['admin', 'superadmin', 'vendor'];

export const ProtectedRoute = ({ children, requiredRoles }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Check specific roles if provided, otherwise require staff role
  const allowedRoles = requiredRoles || STAFF_ROLES;
  if (!allowedRoles.includes(user?.role)) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};
